import React from "react";
import PropTypes from "prop-types";
import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutline";
import ViewIcon from "@material-ui/icons/Visibility";

const useStyles = makeStyles(theme => ({
  select:{
      fontSize: '0.75rem',
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: '0px',
    marginTop: '16px'
  },
  typography: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    letterSpacing: '0.00938em',
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  }
}));

const Booking = ({
  disabled,
  title,
  booking,
  ...props
}) => {

  const classes = useStyles();

  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>
      {booking  
        &&
      booking.subcontact 
        &&
        <>
          <TextField
            id="booking_hansa_code"
            name="booking_hansa_code"
            label="Reserva Cod Hansa"
            disabled={true}
            type="text"
            value={booking.hansa_code}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
          />
          <TextField
            id="booking_hansa_status"
            name="booking_hansa_status"
            label="Reserva Estado"
            disabled={true}
            type="text"
            value={booking.hansa_booking_status}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
          />
          <TextField
            id="booking_driver_name"
            name="booking_driver_name"
            label="Reserva Conductor"
            disabled={true}
            type="text"
            value={booking.subcontact.firstname + ' ' + booking.subcontact.lastname}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
          />
          <TextField
            id="booking_driver_email"
            name="booking_driver_email"
            label="Reserva Conductor Email"
            disabled={true}
            type="text"
            value={booking.subcontact.contact.email}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
          />

        </>
      }

  	</React.Fragment>
  	)
}
export default Booking;
